import type { Action, StoreActionApi } from '@atlassian/react-sweet-state';
import type { State, ThirdPartyEntity } from '../../../../common/types';

type SetThirdPartyStateWithPreselectedWorkspaceIdData = {
	workspaces: ThirdPartyEntity[] | null;
	preSelectedWorkspaceId: string | null;
};

export type SetThirdPartyStateWithPreselectedWorkspaceIdAction = (
	data: SetThirdPartyStateWithPreselectedWorkspaceIdData,
) => Action<State, void, void>;

export const setThirdPartyStateWithPreselectedWorkspaceId =
	({ workspaces, preSelectedWorkspaceId }: SetThirdPartyStateWithPreselectedWorkspaceIdData) =>
	({ getState, setState }: StoreActionApi<State>) => {
		const { thirdPartyState } = getState();

		const baseThirdPartyState = { ...thirdPartyState, workspaces };
		if (preSelectedWorkspaceId === null) {
			setState({ thirdPartyState: baseThirdPartyState });
			return;
		}

		const isValidWorkspaceId = !!workspaces?.find(
			(workspace) => workspace.id === preSelectedWorkspaceId,
		);
		setState({
			thirdPartyState: {
				...baseThirdPartyState,
				selectedWorkspaceId: isValidWorkspaceId ? preSelectedWorkspaceId : null,
			},
		});
	};
